module.exports = __webpack_public_path__ + "media/audios/audio_placeholder-8a12a0c6f78f6a7900f97494484f5e70.mp3";